"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdout = (msg) => {
    process.stdout.write(msg);
};
const stderr = (msg) => {
    process.stderr.write(msg);
};
/**
 * @deprecated `ux` will be removed in the next major. See https://github.com/oclif/core/discussions/999
 */
exports.default = {
    stderr,
    stdout,
};
